import { PayerJCodeEntry } from "../../../../../api/services/narAgentGrid/types";

export interface NarAgentGridJCodeOption {
  id: string;
  label: string;
}

const getStringField = (
  entry: PayerJCodeEntry,
  keys: string[],
): string | null => {
  for (const key of keys) {
    const value = entry[key];
    if (typeof value === "string" && value.trim().length > 0) {
      return value.trim();
    }
  }
  return null;
};

/**
 * Maps auth-grid J-code API rows to MultiSelectWithTag options.
 */
export const mapPayerJCodesToOptions = (
  entries: PayerJCodeEntry[],
): NarAgentGridJCodeOption[] => {
  const optionsById = new Map<string, NarAgentGridJCodeOption>();

  for (const entry of entries) {
    const jCode = getStringField(entry, ["j_code", "jCode"]);
    if (!jCode) {
      continue;
    }

    const drugName = getStringField(entry, ["drug_name", "drugName"]);
    optionsById.set(jCode, {
      id: jCode,
      label: drugName ? `${jCode} - ${drugName}` : jCode,
    });
  }

  return Array.from(optionsById.values()).sort((a, b) =>
    a.id.localeCompare(b.id),
  );
};

/**
 * Filters J-code options for MultiSelectWithTag search.
 */
export const filterNarAgentGridJCodeOptions = async (
  options: NarAgentGridJCodeOption[],
  query: string,
): Promise<NarAgentGridJCodeOption[]> => {
  const trimmed = query.trim();
  if (!trimmed) {
    return options;
  }

  const normalizedQuery = trimmed.toLowerCase();

  const startsWithMatches = options.filter(
    (option) =>
      option.id.toLowerCase().startsWith(normalizedQuery) ||
      option.label.toLowerCase().startsWith(normalizedQuery),
  );
  if (startsWithMatches.length > 0) {
    return startsWithMatches;
  }

  return options.filter(
    (option) =>
      option.id.toLowerCase().includes(normalizedQuery) ||
      option.label.toLowerCase().includes(normalizedQuery),
  );
};
